import { ApplicantOfferStatus, ApplicantStatusReason, IOption } from 'types';

export const offerIssueStatuses = [ApplicantOfferStatus.Conditional, ApplicantOfferStatus.Unconditional];

export const offerNeedsReissueStatuses = [...offerIssueStatuses, ApplicantOfferStatus.Withdrawn];

export const userGeneratedApplicantStatusReasonLabels: Partial<Record<ApplicantStatusReason, string>> = {
  [ApplicantStatusReason.EntryCriteriaNotMet]: 'Entry criteria not met',
  [ApplicantStatusReason.FailedAcademicAssessment]: 'Failed academic assessment',
  [ApplicantStatusReason.FailedCredibilityAssessment]: 'Failed credibility assessment',
  [ApplicantStatusReason.FraudulentApplication]: 'Fraudulent application',
  [ApplicantStatusReason.CourseClosure]: 'Course closure',
  [ApplicantStatusReason.CourseFull]: 'Course full',
  [ApplicantStatusReason.UnableToOfferCourse]: 'Unable to offer course to applicant',
  [ApplicantStatusReason.DeadlineHasPassed]: 'Deadline has passed',
  [ApplicantStatusReason.ClosedByApplicant]: 'Closed by applicant',
  [ApplicantStatusReason.WrongApplicationForm]: 'Wrong application form',
  [ApplicantStatusReason.FailedPreCasInterview]: 'Failed Pre-CAS Interview',
  [ApplicantStatusReason.FailedComplianceInterview]: 'Failed Compliance Interview',
  [ApplicantStatusReason.NegativeQualificationVerification]: 'Negative Qualification Verification',
  [ApplicantStatusReason.DuplicateApplication]: 'Duplicate application',
  [ApplicantStatusReason.InactiveApplication]: 'Inactive application',
  [ApplicantStatusReason.RegionExclusiveToAgent]: 'The region is exclusive to a specific agent',
  [ApplicantStatusReason.Other]: 'Other',
};

export const systemGeneratedApplicantStatusReasonLabels: Partial<Record<ApplicantStatusReason, string>> = {
  [ApplicantStatusReason.AcceptedByApplicant]: 'Accepted by applicant',
  [ApplicantStatusReason.CompletedByApplicant]: 'Completed by applicant',
  [ApplicantStatusReason.WithdrawnOnCompletion]: 'Closed by applicant',
};

export const statusReasonOptions: IOption[] = [
  { label: 'Entry criteria not met', value: ApplicantStatusReason.EntryCriteriaNotMet },
  { label: 'Failed academic assessment', value: ApplicantStatusReason.FailedAcademicAssessment },
  { label: 'Failed credibility assessment', value: ApplicantStatusReason.FailedCredibilityAssessment },
  { label: 'Fraudulent application', value: ApplicantStatusReason.FraudulentApplication },
  { label: 'Course closure', value: ApplicantStatusReason.CourseClosure },
  { label: 'Course full', value: ApplicantStatusReason.CourseFull },
  { label: 'Unable to offer course to applicant', value: ApplicantStatusReason.UnableToOfferCourse },
  { label: 'Deadline has passed', value: ApplicantStatusReason.DeadlineHasPassed },
  { label: 'Closed by applicant', value: ApplicantStatusReason.ClosedByApplicant },
  { label: 'Wrong application form', value: ApplicantStatusReason.WrongApplicationForm },
  { label: 'Failed Pre-CAS Interview', value: ApplicantStatusReason.FailedPreCasInterview },
  { label: 'Failed Compliance Interview', value: ApplicantStatusReason.FailedComplianceInterview },
  { label: 'Negative Qualification Verification', value: ApplicantStatusReason.NegativeQualificationVerification },
  { label: 'Duplicate application', value: ApplicantStatusReason.DuplicateApplication },
  { label: 'Inactive application', value: ApplicantStatusReason.InactiveApplication },
  { label: 'The region is exclusive to a specific agent', value: ApplicantStatusReason.RegionExclusiveToAgent },
  { label: 'Other', value: ApplicantStatusReason.Other },
];

export const OfferTooltipLabels = {
  applicantAccepted: 'The applicant has accepted this offer',
  applicantDeclined: 'Applicant has declined this offer',
  offerWithdrawn: 'Offer withdrawn',
  pendingChanges: 'Offer edited since it was last issued',
  pendingChangesByApplicant: 'Applicant has provided new information',
  newDocumentsCount: (count: number) => {
    if (count === 1) {
      return `${count} new update from applicant`;
    }
    return `${count} new updates from applicant`;
  },
  requirementsNotSatisfied: (count: number) => {
    if (count === 1) {
      return `Offer cannot be issued as ${count} requirement is not satisfied`;
    }
    return `Offer cannot be issued as ${count} requirements are not satisfied`;
  },
};
